export const COUNT_PRIMARY_GROUPS = 'COUNT_PRIMARY_GROUPS';
export const HIDE_ALL_MULTI_LANGUAGE_GROUPS = 'HIDE_ALL_MULTI_LANGUAGE_GROUPS';
export const HIDE_MULTI_LANGUAGE_GROUP = 'HIDE_MULTI_LANGUAGE_GROUP';
export const MAKE_PRIMARY_MULTI_LANGUAGE_GROUP =
  'MAKE_PRIMARY_MULTI_LANGUAGE_GROUP';
export const MOVE_TO_MULTI_LANGUAGE_GROUP = 'MOVE_TO_MULTI_LANGUAGE_GROUP';
export const REMOVE_MULTI_LANGUAGE_GROUP = 'REMOVE_MULTI_LANGUAGE_GROUP';
export const SHOW_ALL_MULTI_LANGUAGE_GROUPS = 'SHOW_ALL_MULTI_LANGUAGE_GROUPS';
export const SHOW_MULTI_LANGUAGE_GROUP = 'SHOW_MULTI_LANGUAGE_GROUP';
